import React from 'react';

function Input({ variant, size, disabled, invalid, value, additionalClasses, ...rest }) {
    let className = "border-1 rounded-md focus:ring-0 " + additionalClasses;

    if (size === "small") {
        className += " py-1 px-2 ";
    } else {
        className += " py-2 px-3 ";
    }

    if (disabled) {
        className += " bg-gray-lightest border-gray-light";
    } else {
        if (invalid) {
            className += " focus:border-red border-red";
        } else {
            switch (variant) {
                case "primary":
                    className += " border-purple text-gray-darkest focus:border-purple";
                    break;
                case "secondary":
                    className += " border-yellow bg-yellow text-gray-darkest focus:border-yellow-darker";
                    break;
                default:
                    className += " border-purple text-gray-darkest focus:border-purple";
                    break;
            }
        }
    }

    return (
        <input className={className} disabled={!!disabled} value={value} {...rest} />
    );
}

export default Input;
